import { Analytics } from './firebase-config.js';
import {
  redirectIfAuth,
  loginWithEmail,
  registerWithEmail,
  loginWithGoogle,
  resendVerificationEmail,
  resetPassword,
  getAuthError,
} from './auth.js';

// Sanitise the ?return= param — must be a relative path, no open-redirect
const rawReturn = new URLSearchParams(window.location.search).get('return') || '';
const returnUrl = rawReturn.startsWith('/') && !rawReturn.startsWith('//') ? rawReturn : '/studio';

// Redirect to the return URL (or /app) if already signed in
redirectIfAuth(returnUrl);
Analytics.trackPageView('login');

// --- Tab switching ---
const tabLogin = document.getElementById('tab-login');
const tabRegister = document.getElementById('tab-register');
const loginForm = document.getElementById('login-form');
const registerForm = document.getElementById('register-form');

function showTab(tab) {
  if (tab === 'login') {
    tabLogin.classList.add('text-indigo-600', 'border-indigo-600');
    tabLogin.classList.remove('text-gray-400', 'border-transparent');
    tabRegister.classList.remove('text-indigo-600', 'border-indigo-600');
    tabRegister.classList.add('text-gray-400', 'border-transparent');
    loginForm.classList.remove('hidden');
    registerForm.classList.add('hidden');
  } else {
    tabRegister.classList.add('text-indigo-600', 'border-indigo-600');
    tabRegister.classList.remove('text-gray-400', 'border-transparent');
    tabLogin.classList.remove('text-indigo-600', 'border-indigo-600');
    tabLogin.classList.add('text-gray-400', 'border-transparent');
    registerForm.classList.remove('hidden');
    loginForm.classList.add('hidden');
  }
  clearError();
}

tabLogin.addEventListener('click', () => showTab('login'));
tabRegister.addEventListener('click', () => showTab('register'));

// Open register tab if URL has #register
if (window.location.hash === '#register') {
  showTab('register');
}

// --- Error display ---
const resendBtn = document.getElementById('btn-resend-verify');

function showError(msg, showResend = false) {
  const el = document.getElementById('auth-error');
  el.textContent = msg;
  el.className = 'mb-3 p-3 bg-red-50 border border-red-200 rounded-lg text-sm text-red-700';
  resendBtn.classList.toggle('hidden', !showResend);
}

function showSuccess(msg) {
  const el = document.getElementById('auth-error');
  el.textContent = msg;
  el.className = 'mb-5 p-3 bg-green-50 border border-green-200 rounded-lg text-sm text-green-700';
  resendBtn.classList.add('hidden');
}

function clearError() {
  const el = document.getElementById('auth-error');
  el.textContent = '';
  el.className = 'hidden';
  resendBtn.classList.add('hidden');
}

function setLoading(btnId, isLoading, label) {
  const btn = document.getElementById(btnId);
  btn.disabled = isLoading;
  btn.textContent = isLoading ? 'Please wait…' : label;
}

// --- Login ---
loginForm.addEventListener('submit', async (e) => {
  e.preventDefault();
  clearError();
  const email = document.getElementById('login-email').value.trim();
  const password = document.getElementById('login-password').value;

  setLoading('btn-login', true, 'Sign in');
  try {
    await loginWithEmail(email, password);
    // Also consume any pending return URL saved during registration
    const pending = localStorage.getItem('pendingReturnUrl');
    localStorage.removeItem('pendingReturnUrl');
    window.location.href = pending || returnUrl;
  } catch (err) {
    showError(getAuthError(err.code), err.code === 'auth/email-not-verified');
    setLoading('btn-login', false, 'Sign in');
  }
});

// --- Register ---
registerForm.addEventListener('submit', async (e) => {
  e.preventDefault();
  clearError();
  const name = document.getElementById('register-name').value.trim();
  const email = document.getElementById('register-email').value.trim();
  const password = document.getElementById('register-password').value;

  if (!name) { showError('Please enter your name.'); return; }

  setLoading('btn-register', true, 'Create account');
  try {
    await registerWithEmail(email, password, name);
    // Save return URL so it survives the email verification detour
    if (returnUrl !== '/app') localStorage.setItem('pendingReturnUrl', returnUrl);
    showSuccess('Account created! Check your inbox (and spam folder) for a verification link before signing in.');
    setLoading('btn-register', false, 'Create account');
    registerForm.reset();
  } catch (err) {
    showError(getAuthError(err.code));
    setLoading('btn-register', false, 'Create account');
  }
});

// --- Resend verification ---
resendBtn.addEventListener('click', async () => {
  const email = document.getElementById('login-email').value.trim();
  const password = document.getElementById('login-password').value;
  resendBtn.disabled = true;
  resendBtn.textContent = 'Sending…';
  try {
    await resendVerificationEmail(email, password);
    showSuccess('Verification email resent! Check your inbox (and spam folder).');
  } catch (err) {
    showError(getAuthError(err.code), true);
  }
  resendBtn.disabled = false;
  resendBtn.textContent = 'Resend verification email';
});

// --- Google ---
document.getElementById('btn-google').addEventListener('click', async () => {
  clearError();
  try {
    await loginWithGoogle();
    const pending = localStorage.getItem('pendingReturnUrl');
    localStorage.removeItem('pendingReturnUrl');
    window.location.href = pending || returnUrl;
  } catch (err) {
    showError(getAuthError(err.code));
  }
});

document.getElementById('btn-reset-password').addEventListener('click', async () => {
  clearError();
  const email = document.getElementById('login-email').value.trim();
  if (!email) {
    showError('Enter your email first, then choose Reset password.');
    return;
  }
  try {
    await resetPassword(email);
    showSuccess('Password reset email sent. Check your inbox and spam folder.');
  } catch (err) {
    showError(getAuthError(err.code));
  }
});
